import { DefectCollectionsManager } from "../../features/catalogues/DefectCollectionsManager.js";

export function DefectCollectionsPage() {
  return <DefectCollectionsManager />;
}
